import { SMARTCARD_BG_URLS } from "./smartcardBackgrounds";

export default function SmartCardBackground({ tier }) {
  const bgUrl = SMARTCARD_BG_URLS[tier] || SMARTCARD_BG_URLS.Silver;

  return (
    <img
      src={bgUrl}
      alt={`${tier} SmartCard`}
      className="absolute inset-0 h-full w-full object-cover"
    />
  );
}
